import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.818 1.86582C12.0132 1.77833 12.2364 1.77833 12.4316 1.86582L17.5566 4.16323C17.8263 4.28412 17.9998 4.55209 17.9998 4.84762C17.9998 5.14314 17.8263 5.41111 17.5566 5.532L12.4316 7.82941C12.2364 7.9169 12.0132 7.9169 11.818 7.82941L6.69303 5.532C6.42336 5.41111 6.24982 5.14314 6.24982 4.84762C6.24982 4.55209 6.42336 4.28412 6.69303 4.16323L11.818 1.86582ZM8.83331 4.84762L12.1248 6.32312L15.4163 4.84762L12.1248 3.37211L8.83331 4.84762Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.31544 10.196C6.48487 9.81802 6.92864 9.64897 7.30661 9.81841L12.1248 11.9783L16.943 9.81841C17.321 9.64897 17.7648 9.81802 17.9342 10.196C18.1036 10.574 17.9346 11.0177 17.5566 11.1872L12.4316 13.4846C12.2364 13.5721 12.0132 13.5721 11.818 13.4846L6.69303 11.1872C6.31505 11.0177 6.146 10.574 6.31544 10.196Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2498 4.09762C17.664 4.09762 17.9998 4.4334 17.9998 4.84762L17.9998 10.5028C17.9998 10.917 17.664 11.2528 17.2498 11.2528C16.8356 11.2528 16.4998 10.917 16.4998 10.5028V4.84762C16.4998 4.4334 16.8356 4.09762 17.2498 4.09762Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.99982 4.09762C7.41403 4.09762 7.74982 4.4334 7.74982 4.84762V10.5028C7.74982 10.917 7.41403 11.2528 6.99982 11.2528C6.58561 11.2528 6.24982 10.917 6.24982 10.5028V4.84762C6.24982 4.4334 6.58561 4.09762 6.99982 4.09762Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1248 6.57175C12.539 6.57175 12.8748 6.90754 12.8748 7.32175V12.6235C12.8748 13.0377 12.539 13.3735 12.1248 13.3735C11.7106 13.3735 11.3748 13.0377 11.3748 12.6235V7.32175C11.3748 6.90754 11.7106 6.57175 12.1248 6.57175Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.818 9.86582C17.0132 9.77833 17.2364 9.77833 17.4316 9.86582L22.5566 12.1632C22.8263 12.2841 22.9998 12.5521 22.9998 12.8476C22.9998 13.1431 22.8263 13.4111 22.5566 13.532L17.4316 15.8294C17.2364 15.9169 17.0132 15.9169 16.818 15.8294L11.693 13.532C11.4234 13.4111 11.2498 13.1431 11.2498 12.8476C11.2498 12.5521 11.4234 12.2841 11.693 12.1632L16.818 9.86582ZM13.8333 12.8476L17.1248 14.3231L20.4163 12.8476L17.1248 11.3721L13.8333 12.8476Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3154 18.196C11.4849 17.818 11.9286 17.649 12.3066 17.8184L17.1248 19.9783L21.943 17.8184C22.321 17.649 22.7648 17.818 22.9342 18.196C23.1036 18.574 22.9346 19.0177 22.5566 19.1872L17.4316 21.4846C17.2364 21.5721 17.0132 21.5721 16.818 21.4846L11.693 19.1872C11.3151 19.0177 11.146 18.574 11.3154 18.196Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.2498 12.0976C22.664 12.0976 22.9998 12.4334 22.9998 12.8476L22.9998 18.5028C22.9998 18.917 22.664 19.2528 22.2498 19.2528C21.8356 19.2528 21.4998 18.917 21.4998 18.5028V12.8476C21.4998 12.4334 21.8356 12.0976 22.2498 12.0976Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9998 12.0976C12.414 12.0976 12.7498 12.4334 12.7498 12.8476V18.5028C12.7498 18.917 12.414 19.2528 11.9998 19.2528C11.5856 19.2528 11.2498 18.917 11.2498 18.5028V12.8476C11.2498 12.4334 11.5856 12.0976 11.9998 12.0976Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1248 14.5718C17.539 14.5718 17.8748 14.9075 17.8748 15.3218V20.6235C17.8748 21.0377 17.539 21.3735 17.1248 21.3735C16.7106 21.3735 16.3748 21.0377 16.3748 20.6235V15.3218C16.3748 14.9075 16.7106 14.5718 17.1248 14.5718Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.81803 9.86582C7.0132 9.77833 7.23644 9.77833 7.43161 9.86582L12.5566 12.1632C12.8263 12.2841 12.9998 12.5521 12.9998 12.8476C12.9998 13.1431 12.8263 13.4111 12.5566 13.532L7.43161 15.8294C7.23644 15.9169 7.0132 15.9169 6.81803 15.8294L1.69303 13.532C1.42336 13.4111 1.24982 13.1431 1.24982 12.8476C1.24982 12.5521 1.42336 12.2841 1.69303 12.1632L6.81803 9.86582ZM3.83331 12.8476L7.12482 14.3231L10.4163 12.8476L7.12482 11.3721L3.83331 12.8476Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.31544 18.196C1.48487 17.818 1.92864 17.649 2.30661 17.8184L7.12482 19.9783L11.943 17.8184C12.321 17.649 12.7648 17.818 12.9342 18.196C13.1036 18.574 12.9346 19.0177 12.5566 19.1872L7.43161 21.4846C7.23644 21.5721 7.0132 21.5721 6.81803 21.4846L1.69303 19.1872C1.31505 19.0177 1.146 18.574 1.31544 18.196Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2498 12.0976C12.664 12.0976 12.9998 12.4334 12.9998 12.8476V18.5028C12.9998 18.917 12.664 19.2528 12.2498 19.2528C11.8356 19.2528 11.4998 18.917 11.4998 18.5028V12.8476C11.4998 12.4334 11.8356 12.0976 12.2498 12.0976Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.99982 12.0976C2.41403 12.0976 2.74982 12.4334 2.74982 12.8476V18.5028C2.74982 18.917 2.41403 19.2528 1.99982 19.2528C1.58561 19.2528 1.24982 18.917 1.24982 18.5028V12.8476C1.24982 12.4334 1.58561 12.0976 1.99982 12.0976Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.12482 14.5718C7.53903 14.5718 7.87482 14.9075 7.87482 15.3218V20.6235C7.87482 21.0377 7.53903 21.3735 7.12482 21.3735C6.71061 21.3735 6.37482 21.0377 6.37482 20.6235V15.3218C6.37482 14.9075 6.71061 14.5718 7.12482 14.5718Z"
      fill="currentColor"
    />
  </SvgIcon>
));
